import { helpers } from 'autenti-components';

export const getOrganizationId = () => {
  return helpers.getCookie('organizationId');
};
